<style scoped>
.edit {
    background-color: antiquewhite !important;
}
</style>

<template>
    <el-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
        :formatter="formatter"
		:width="width"
        >
        <template v-if="col.children && !col.show">
            <my-column
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :editField="editField"
                :editFieldType ="editFieldType"
				:width="width">
            </my-column>
        </template>
        <template slot-scope="scope"> 
        <input v-if="scope.row.edit == scope.column.property && editFieldType[editField.indexOf(scope.column.property)]=='text'"  type="text" autocomplete="off" class="el-input__inner" @blur="scope.row.edit = true"/>
        <el-date-picker v-else-if="scope.row.edit == scope.column.property  && editFieldType[editField.indexOf(scope.column.property)]=='date'"
          v-model="scope.row[scope.column.property]"
          style="width: 100%"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="scope.row.pickerOptions"
          @blur="scope.row.edit = false">
        </el-date-picker>
        <span v-else-if="scope.row[scope.column.property].length == 0 && editFieldType[editField.indexOf(scope.column.property)]=='text'">请输入</span>
        <span v-else-if="scope.row[scope.column.property].length == 0 && editFieldType[editField.indexOf(scope.column.property)]=='date'">请选择</span>
        <span v-else>{{ scope.row[scope.column.property] }}</span>
      </template>
    </el-table-column>
</template>

<script>
export default {
    name: "MyColumn",
    data() {
        return {
            field:[]
        };
    },
    props: {
        col: {
            type: Object
        },
        editField:{
            type: Array
        },
        editFieldType:{
            type: Array
        },
		width:{
			type: String
		}
	},
    methods: {
        formatter(row, column, cellValue, index) {
            let indexEdit = this.editField.indexOf(column.property);
            if(indexEdit != -1) {
             if(cellValue.length >0){
                 return cellValue;
             }else{
                 if(this.editFieldType[indexEdit] == "text"){
                     return '请输入';
                 }else if(this.editFieldType[indexEdit] == "date"){
                    return '请选择';
                 }
                 

             }
            } else {
                return cellValue;
            }
        }
    }
};
</script>
<style scoped>
</style>